/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContractSummary } from './ContractSummary';
import {
    ContractSummaryFromJSON,
    ContractSummaryFromJSONTyped,
    ContractSummaryToJSON,
} from './ContractSummary';
import type { PalSubmissionListEntryTimExecutionPayor } from './PalSubmissionListEntryTimExecutionPayor';
import {
    PalSubmissionListEntryTimExecutionPayorFromJSON,
    PalSubmissionListEntryTimExecutionPayorFromJSONTyped,
    PalSubmissionListEntryTimExecutionPayorToJSON,
} from './PalSubmissionListEntryTimExecutionPayor';
import type { PalSubmissionListEntryTimExecutionReportResult } from './PalSubmissionListEntryTimExecutionReportResult';
import {
    PalSubmissionListEntryTimExecutionReportResultFromJSON,
    PalSubmissionListEntryTimExecutionReportResultFromJSONTyped,
    PalSubmissionListEntryTimExecutionReportResultToJSON,
} from './PalSubmissionListEntryTimExecutionReportResult';

/**
 * Subset of TimExecution for list view
 * @export
 * @interface PalSubmissionListEntryTimExecution
 */
export interface PalSubmissionListEntryTimExecution {
    /**
     * 
     * @type {PalSubmissionListEntryTimExecutionPayor}
     * @memberof PalSubmissionListEntryTimExecution
     */
    payor?: PalSubmissionListEntryTimExecutionPayor;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryTimExecution
     */
    insurance_type?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryTimExecution
     */
    reimbursement_type?: string;
    /**
     * 
     * @type {PalSubmissionListEntryTimExecutionReportResult}
     * @memberof PalSubmissionListEntryTimExecution
     */
    report_result?: PalSubmissionListEntryTimExecutionReportResult;
    /**
     * 
     * @type {ContractSummary}
     * @memberof PalSubmissionListEntryTimExecution
     */
    contract?: ContractSummary;
}

/**
 * Check if a given object implements the PalSubmissionListEntryTimExecution interface.
 */
export function instanceOfPalSubmissionListEntryTimExecution(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalSubmissionListEntryTimExecutionFromJSON(json: any): PalSubmissionListEntryTimExecution {
    return PalSubmissionListEntryTimExecutionFromJSONTyped(json, false);
}

export function PalSubmissionListEntryTimExecutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryTimExecution {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payor': !exists(json, 'payor') ? undefined : PalSubmissionListEntryTimExecutionPayorFromJSON(json['payor']),
        'insurance_type': !exists(json, 'insurance_type') ? undefined : json['insurance_type'],
        'reimbursement_type': !exists(json, 'reimbursement_type') ? undefined : json['reimbursement_type'],
        'report_result': !exists(json, 'report_result') ? undefined : PalSubmissionListEntryTimExecutionReportResultFromJSON(json['report_result']),
        'contract': !exists(json, 'contract') ? undefined : ContractSummaryFromJSON(json['contract']),
    };
}

export function PalSubmissionListEntryTimExecutionToJSON(value?: PalSubmissionListEntryTimExecution | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payor': PalSubmissionListEntryTimExecutionPayorToJSON(value.payor),
        'insurance_type': value.insurance_type,
        'reimbursement_type': value.reimbursement_type,
        'report_result': PalSubmissionListEntryTimExecutionReportResultToJSON(value.report_result),
        'contract': ContractSummaryToJSON(value.contract),
    };
}

